import { useTenantSettings } from "@appretio/shared";

/** Whether this tenant's budget versions are keyed by brand or span the tenant. */
export type BudgetScope = "brand" | "tenant";

/**
 * The tenant's budget scope, from its `budget_scope` setting, or undefined
 * while the settings load: no dimensions gives the tenant a single budget
 * with no brand on it; otherwise every budget version is keyed to one brand,
 * the only dimension budgets support today. A failed read gives `"brand"`.
 */
export function useResolvedBudgetScope(): BudgetScope | undefined {
  const { data, isError } = useTenantSettings();
  if (!data) return isError ? "brand" : undefined;
  return data.settings.budget_scope.value.length > 0 ? "brand" : "tenant";
}

/**
 * The tenant's budget scope, reporting `"brand"` until the settings resolve:
 * the stricter of the two, so a slow or failed read leaves the create
 * disabled rather than briefly offering one the API would reject.
 */
export function useBudgetScope(): BudgetScope {
  return useResolvedBudgetScope() ?? "brand";
}
